import uiCore = require("../core/uicore");
import dataCore = require("../core/datacore");
import fileInput = require("../core/fileinput.directive");
import entityCache = require("../core/entitycache");
import entityHelper = require("../core/entityhelper");

export class PersonCompetenceStateParams {
    personCompetenceId: number;
    personId: number;
}

export class PersonCompetenceStateStrings {
    public static List = "resources.persons.detail";
    public static Details = "personcompetencesdetails";
    public static New = "personcompetencesnew";
    public static Edit = "personcompetencesedit";
}

export function downloadAttachment(personCompetenceId: number) {
    if (personCompetenceId >= 0) window.open(entityHelper.FileContentHelper.FormatFullUrl(entityHelper.FileContentHelper.FormatPersonCompetenceAttachmentServiceUrl(personCompetenceId)));
}

export function viewComment(comment: string, $mdDialog: ng.material.IDialogService) {
    $mdDialog.show($mdDialog.alert()
        .title("Competence comment")
        .textContent(comment)
        .ok('Ok'));
}

export class PersonCompetencesDetailsBase {

    public static BaseAngularDependencies: uiCore.IAngularDependencyId[] = [uiCore.ScopeDependency, uiCore.StateParamsDependency, uiCore.StateDependency, uiCore.MdDialogDependency];

    public person: Nema.Crew.Model.Person;
    public personCompetence: Nema.Crew.Model.PersonCompetence;

    public competenceTypes: Nema.Crew.Model.CompetenceType[];

    protected dataCache: entityCache.EntityCache;

    private _isNew: boolean;
    private _changesResolved: boolean;
    protected _locator: uiCore.DependencyLocator;

    attachmentfilecontenthelper: entityHelper.FileContentHelper;

    constructor(isNew: boolean, onDataLoaded: () => void, component: uiCore.IComponentWithDescription, injected: any[]) {
        this._changesResolved = false;
        this._isNew = isNew;
        
        this._locator = uiCore.DependencyLocator.Create(component, injected);
        var state = <PersonCompetenceStateParams><any>this._locator.getStateParamsDependency();

        this.dataCache = new entityCache.EntityCache(entityCache.CommonEntityManagers.EntityManager);
        var dataDependencies: string[] = [
            entityCache.EntityTypeNames.PersonCompetence,
            entityCache.EntityTypeNames.Person,
            entityCache.EntityTypeNames.CompetenceType,
        ];

        var entitiesPromise = this.dataCache.getEntitySetsPromise(dataDependencies);
        var self = this;

        entitiesPromise.then(res => {
            this.initializedata(isNew, res, state.personCompetenceId, state.personId);
            if (onDataLoaded) {
                onDataLoaded();
            }
            self._locator.getScopeDependency().$apply();
        }).catch(_reason => {
        });
    }

    protected initializedata(isNew: boolean, res: entityCache.EntitySetDictionary, personCompetencesId: number, personId: number) {
        
        this.competenceTypes = <any>res[entityCache.EntityTypeNames.CompetenceType];

        if (isNew) {
            this.person = <any>this.dataCache.getEntity(entityCache.EntityTypeNames.Person, personId);
            if (!this.person) return;
            var newPersonCompetence = <Nema.Crew.Model.PersonCompetence> { PersonId: this.person.Id, ValidFrom: dataCore.getToday(), Expiration: dataCore.DateMaxInfinity, AcquirementStartDate: dataCore.DateMinInfinity, AcquirementEndDate: dataCore.DateMaxInfinity  };
            this.personCompetence = <any>this.dataCache.entityManager.createEntity(entityCache.EntityTypeNames.PersonCompetence, newPersonCompetence);
        }
        else {
            this.personCompetence = <any>this.dataCache.getEntity(entityCache.EntityTypeNames.PersonCompetence, personCompetencesId);
            if (!this.personCompetence) return;
            this.person = <any>this.dataCache.getEntity(entityCache.EntityTypeNames.Person, this.personCompetence.PersonId);
        }

        this.attachmentfilecontenthelper = new entityHelper.FileContentHelper(
            this._locator.getMdDialogDependency(),
            this._locator.getScopeDependency(),
            false,
            this.personCompetence.HasAttachment,
            100
            );
    }

    protected goToList = () => {
        this._locator
            .getStateDependency()
            .go("app." + PersonCompetenceStateStrings.List, { personId: this.person.Id });
    }

    protected goToDetails = () => {
        this._locator.getStateDependency().go("app." + PersonCompetenceStateStrings.Details, <PersonCompetenceStateParams> { personCompetenceId: this.personCompetence.Id, personId: this.personCompetence.PersonId });
    }

    public edit() {
        this._locator
            .getStateDependency()
            .go("app." + PersonCompetenceStateStrings.Edit, <PersonCompetenceStateParams> { personCompetenceId: this.personCompetence.Id, personId: this.personCompetence.PersonId });
    }

    public cancel() {
        this._changesResolved = true;
        this.dataCache.entityManager.rejectChanges();
        if (this._isNew) {
            this.goToList();
        }
        else {
            this.goToDetails();
        }
    }

    public viewAttachment() {
        if (this.personCompetence && this.personCompetence.HasAttachment) downloadAttachment(this.personCompetence.Id);
    }

    public querySearchCompetenceType(searchString: string): Nema.Crew.Model.CompetenceType[] {
        return <any[]> this.dataCache.searchActiveByName(entityCache.EntityTypeNames.CompetenceType, searchString);
    }
    
    private fileinputdirectiveapi: fileInput.ICrewFileReadApi = <any> {};

    setAttachment() {
        this.fileinputdirectiveapi.click();
    }

    public save() {
        var listOfChanges = [
            () => { }, // First save simple properties
            () => { // Then handle attachment
                if (!this.attachmentfilecontenthelper.hasChanges()) return;
                // PersonCompetence is correctly updated at this point - also for new PersonCompetence
                return this.attachmentfilecontenthelper.applyChanges(entityHelper.FileContentHelper.FormatPersonCompetenceAttachmentServiceUrl(this.personCompetence.Id));
            },
            () => { // Refresh data (causes "PersonCompetence.HasAttachment) to be set correctly
                return this.dataCache.refreshEntities(<any>[this.personCompetence]);
            }
        ];
        this._changesResolved = true;
        entityHelper.saveSequentialListOfChangesAndNavigate(listOfChanges, this.dataCache.entityManager, this.goToDetails, this._locator.getStateDependency());
    }

    public hasChanges() {
        if (this._changesResolved) return false;
        if (this._isNew) return true;
        if (this.attachmentfilecontenthelper.hasChanges()) return true;
        if (this.dataCache.entityManager.hasChanges()) return true;
        return false;
    }
    public delete() {

        var listOfChanges = [
            () => {
                (<breeze.Entity><any>this.personCompetence).entityAspect.setDeleted();
            }
        ];

        entityHelper
            .confirmedSaveSequentialListOfChangesAndNavigate(
            listOfChanges,
            "Delete Person Competence",
            "Please confirm to delete person competence",
            this.dataCache.entityManager,
            this._locator.getMdDialogDependency(),
            this.goToList,
            this._locator.getStateDependency());
    }
}

export class PersonCompetencesDetails extends PersonCompetencesDetailsBase implements uiCore.IDirective {

    public static ComponentDescription: uiCore.IStandardPageDescription = {
        DirectiveId: PersonCompetenceStateStrings.Details,
        Url: "/personcompetence/{personCompetenceId:int}",
        HeaderText: "Person Competence details",
        StateString: PersonCompetenceStateStrings.Details,
        Template: require("./personcompetences.details.html"),
        AngularDependencies: [].concat(PersonCompetencesDetailsBase.BaseAngularDependencies),
    }

    constructor(...args: any[]) {
        super(false,() => {
        }, PersonCompetencesDetails, args);
    }
}

export class PersonCompetencesEdit extends PersonCompetencesDetailsBase implements uiCore.IDirective {

    public static ComponentDescription: uiCore.IStandardPageDescription = {
        DirectiveId: PersonCompetenceStateStrings.Edit,
        Url: "/personcompetence/edit/{personCompetenceId:int}",
        HeaderText: "Edit Person Competence",
        StateString: PersonCompetenceStateStrings.Edit,
        Template: require("./personcompetences.edit.html"),
        AngularDependencies: [].concat(PersonCompetencesDetailsBase.BaseAngularDependencies),
    }

    constructor(...args: any[]) {
        super(false,() => {
        }, PersonCompetencesEdit, args);
    }
}

export class PersonCompetencesNew extends PersonCompetencesDetailsBase implements uiCore.IDirective {

    public static ComponentDescription: uiCore.IStandardPageDescription = {
        DirectiveId: PersonCompetenceStateStrings.New,
        Url: "/personcompetence/new/{personId:int}",
        HeaderText: "New Person Competence",
        StateString: PersonCompetenceStateStrings.New,
        Template: require("./personcompetences.new.html"),
        AngularDependencies: [].concat(PersonCompetencesDetailsBase.BaseAngularDependencies),
    }

    constructor(...args: any[]) {
        super(true,() => {
        }, PersonCompetencesNew, args);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/personcompetences.common.ts